/* TWRD menu drawer search.
   The drawer field does not open a second dialog. It switches the drawer to a
   search state inside the same dialog, hosting the existing search panel from
   twrd-search-overlay.js. The back chevron and Escape return to the menu. */
(function () {
  'use strict';

  var MODAL_ID = 'modal-main-menu';
  var SEARCH_MODE = 'twrd-search-mode';

  var modal = null;
  var host = null;
  var field = null;
  /* Returning to the menu refocuses the field. Without this the field's own
     focus handler would reopen search immediately. */
  var suppressFocusOpen = false;

  function api() {
    return window.twrdSearchInline || null;
  }

  function inSearchMode() {
    return !!modal && modal.classList.contains(SEARCH_MODE);
  }

  function openSearch(prefill) {
    var inline = api();
    if (!modal || !host || !inline) return false;
    if (inSearchMode()) {
      if (prefill) inline.type(prefill);
      return true;
    }
    /* The host is display:none until this class lands. Focus would be refused
       on a hidden input, so the state swap has to come first. */
    modal.classList.add(SEARCH_MODE);
    if (!inline.open(host)) {
      modal.classList.remove(SEARCH_MODE);
      return false;
    }
    if (field) {
      field.setAttribute('aria-expanded', 'true');
      field.value = '';
    }
    inline.focusInput();
    if (prefill) inline.type(prefill);
    return true;
  }

  function backToMenu() {
    var inline = api();
    if (!inSearchMode()) return;
    if (inline) inline.close();
    modal.classList.remove(SEARCH_MODE);
    if (field) {
      field.setAttribute('aria-expanded', 'false');
      field.value = '';
      suppressFocusOpen = true;
      try {
        field.focus();
      } catch (error) {
        /* focus can be refused right after the state swap */
      }
      window.setTimeout(function () {
        suppressFocusOpen = false;
      }, 0);
    }
  }

  /* Escape must return to the menu, never close the whole drawer, so this runs
     in the capture phase ahead of the dialog's own handler. */
  function onKeydown(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    if (!inSearchMode()) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    backToMenu();
  }

  function bindField() {
    if (!field || field.dataset.twrdDrawerReady === 'true') return;
    field.dataset.twrdDrawerReady = 'true';
    field.setAttribute('aria-expanded', 'false');

    /* pointerdown keeps the hand-over inside the user gesture, so iOS keeps
       the keyboard up when focus moves to the panel input. */
    field.addEventListener('pointerdown', function (event) {
      if (suppressFocusOpen) return;
      event.preventDefault();
      openSearch('');
    });

    field.addEventListener('focus', function () {
      if (suppressFocusOpen) return;
      if (inSearchMode()) return;
      var stray = field.value;
      field.blur();
      openSearch(stray);
    });

    /* Anything that lands in the facade before the swap is carried over. */
    field.addEventListener('input', function () {
      if (suppressFocusOpen) return;
      var stray = field.value;
      field.value = '';
      openSearch(stray);
    });

    field.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      if (!field.value.trim()) event.preventDefault();
    });
  }

  function init() {
    modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    host = modal.querySelector('[data-twrd-drawer-searchhost]');
    field = modal.querySelector('[data-twrd-drawer-searchfield]');
    bindField();

    if (modal.dataset.twrdDrawerReady === 'true') return;
    modal.dataset.twrdDrawerReady = 'true';

    document.addEventListener('keydown', onKeydown, true);

    /* Delegated: the back chevron lives in the panel, which is moved in and
       out of this drawer, so a direct listener would go stale. */
    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      if (!event.target.closest('[data-twrd-search-back]')) return;
      if (!inSearchMode()) return;
      event.preventDefault();
      event.stopPropagation();
      backToMenu();
    });

    /* Closing the drawer must not leave the panel parked inside it. */
    modal.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      if (event.target.closest('[data-a11y-dialog-hide]')) backToMenu();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
